import React, { useRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useOnScreenFromBottom } from 'site-modules/shared/hooks/use-on-screen-from-bottom';

export function OnScreenContentWrapper({ children = null, className = null }) {
  const ref = useRef();
  const [isOnScreen, isIntersectingFromBottom] = useOnScreenFromBottom(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  return (
    <div
      className={classnames('on-screen-content-wrapper', className, {
        'is-intersecting': isOnScreen,
        'is-intersecting-from-bottom': isIntersectingFromBottom,
      })}
      ref={ref}
    >
      {children}
    </div>
  );
}

OnScreenContentWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
